document.addEventListener("DOMContentLoaded", () => {
	const poll = setInterval(() => {
		const locationsList = document.querySelector("#sl_addresses > li");
		if (locationsList) {
			clearInterval(poll);

			setTimeout(() => {
                document.querySelectorAll("#sl_addresses > li > a").forEach(link => {
                link.removeAttribute("href");
				link.removeAttribute("target");
			});
            }, 100);
		}
	}, 100);

	setTimeout(() => clearInterval(poll), 15000);
});


function initMutationObserver() {
  const targetNode = document.body;
  const observerOptions = {
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let container_open = document.getElementById('col-main');

        if (container_open) {
          // console.log(`Class "${container?.className}" and "${container_open?.id}" or "${reward_info?.id}" are now present in the DOM.`);
          document.querySelectorAll("#sl_addresses li").forEach(item => {
			item.addEventListener("click", function(event) {
				event.preventDefault();
				// console.log("def beh prevented for:", this);
			});
			});
        }
      }
    }
  });

  observer.observe(targetNode, observerOptions);
}

document.addEventListener('DOMContentLoaded', initMutationObserver);

